/**
 * AES-128-ECB 加解密（兼容原 crypto-js 实现）
 */
import {
  aesEncryptToBase64,
  aesDecryptFromBase64OrHex,
} from "./aesEcb.js";

const keyStr = "JXU2OPM3KXU1NkU0";

export function encrypt(word) {
  return aesEncryptToBase64(word, keyStr || "abcdefgabcdefg12");
}

export function decrypt(word) {
  return aesDecryptFromBase64OrHex(word, keyStr || "abcdefgabcdefg12");
}
